import { MultiValuedListMore } from '../../../../../MultiValuedList'

import * as styles from './More.module.css'

function More(props) {
  return (
    <MultiValuedListMore
      {...props}
      className={styles.more}
      size='large'
      variant='tag'
    />
  )
}

export default More
